/** @flow */

import * as actions from "@modules/shared/constants/actions";
import * as absenceReasonsReducers from "./reducers";
import initialState from "./state";
import type { SpecialContactTypesState } from "./types";
import { cloneObject } from "@utils/object";

export default (state: SpecialContactTypesState = initialState, action: Object): Object => {
  const act = {
    [actions.GetSpecialContactTypes]: absenceReasonsReducers.onGetSpecialContactTypes,
    [actions.GetSpecialContactTypesSuccess]: absenceReasonsReducers.onGetSpecialContactTypesSuccess,
    [actions.GetSpecialContactTypesError]: absenceReasonsReducers.onGetSpecialContactTypesError,
  };

  if (action && action.type && act && act[action.type]) {
    return act[action.type](cloneObject(state))(action);
  }
  return state;
};
